import { Node as ProsemirrorNode } from '@tiptap/pm/model'
import { EditorState, TextSelection } from '@tiptap/pm/state'
import { EditorView } from '@tiptap/pm/view'

type FindNode = { offset: number; node: ProsemirrorNode }

export const findNode = (
  state: EditorState,
  predicate: (node: ProsemirrorNode) => boolean,
): FindNode | undefined => {
  let found: FindNode
  state.doc.descendants((node, offset) => {
    if (predicate(node)) {
      found = { node, offset }
    }
    if (found) {
      return false
    }

    return undefined
  })
  return found
}

export const setNodeAttrById = (
  view: EditorView,
  nodeType: ProsemirrorNode['type'],
  id: string,
  newAttrs: { [key: string]: unknown } = {},
  addToHistory = true,
): void => {
  const foundNode = findNode(view.state, node => node.attrs.id === id)
  if (!foundNode) {
    return
  }

  const { offset, node: imageNode } = foundNode
  const tr = view.state.tr.setMeta('addToHistory', addToHistory)

  tr.setNodeMarkup(offset, nodeType, newAttrs)

  const resolvedPos = tr.doc.resolve(offset + imageNode.nodeSize)
  const selection = new TextSelection(resolvedPos)

  tr.setSelection(selection).scrollIntoView()
  view.dispatch(tr)
  view.focus()
}
